import ListView from '../../../components/listView/ListView'
import Page from '../../../components/pageView/Page'
import StatsPage from '../../../pages/apps/admin/StatsPage'

const routesAdmin = [
    // Employee
    {
        path: '/admin/employee',
        element: ListView,
        props: { type: 'employeeList' }
    },
    {
        path: '/admin/employee/new',
        element: Page,
        props: { type: 'employeeCard', options: { mode: 'new', load: false } }
    },
    {
        path: '/admin/employee/:id',
        element: Page,
        props: { type: 'employeeCard', options: { mode: 'edit', load: true } }
    },
    // Organization (moved from /home)
    {
        path: '/admin/organization',
        element: ListView,
        props: { type: 'organizationList' }
    },
    {
        path: '/admin/organization/new',
        element: Page,
        props: { type: 'organizationCard', options: { mode: 'new' } }
    },
    {
        path: '/admin/organization/:id',
        element: Page,
        props: { type: 'organizationCard', options: { mode: 'edit', load: true } }
    },
    // Users (moved from /home)
    {
        path: '/admin/user',
        element: ListView,
        props: { type: 'userList' }
    },
    {
        path: '/admin/user/new',
        element: Page,
        props: { type: 'userCardNew', options: { mode: 'new' } }
    },
    {
        path: '/admin/user/:id',
        element: Page,
        props: { type: 'userCard', options: { mode: 'edit', load: true } }
    },
    // Portals (moved from /home)
    {
        path: '/admin/portals',
        element: ListView,
        props: { type: 'portalList' }
    },
    {
        path: '/admin/portals/new',
        element: Page,
        props: { type: 'portalPage', options: { mode: 'new', load: false } }
    },
    {
        path: '/admin/portals/:id',
        element: Page,
        props: { type: 'portalPage', options: { mode: 'edit', load: true } }
    },
    // Periodic › Statistics: rebuild the stats behind the overview widgets
    {
        path: '/admin/stats',
        element: StatsPage,
        props: {}
    },
    // Admin Settings
    {
        path: '/admin/settings',
        element: Page,
        props: { type: 'adminSettingsPage', options: { mode: 'edit', load: true, onMount: 'collapse' } }
    }
]

export default routesAdmin
